import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=3ec88bc2&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=3ec88bc2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src741664602/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec88bc2"]])

export default __exports__